import { useGetNewsFeedQuery } from "../store/api/newsApi";
import styles from "./NewsFeed.module.css";
const parseCaption = (caption = "") => {
  const lines = caption
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  const whyIndex = lines.findIndex((line) =>
    line.toLowerCase().startsWith("why it matters")
  );

  return {
    point: lines[1] || "",
    description: lines[2] || "",
    whyItMatters:
      whyIndex !== -1
        ? lines[whyIndex].replace(/why it matters:\s*/i, "")
        : "",
  };
};


export default function NewsFeed() {
  const {
    data: news = [],
    isLoading,
    isError,
    refetch,
  } = useGetNewsFeedQuery();

  if (isLoading) {
    return <div className={styles.loading}>Loading news...</div>;
  }

  if (isError) {
    return (
      <div className={styles.error}>
        <h3>Failed to load news</h3>
        <button onClick={refetch}>Retry</button>
      </div>
    );
  }

  return (
    <div className={styles.newsContainer}>
      {news.map((item) => {
        const { point, description, whyItMatters } = parseCaption(
          item.caption
        );

        return (
          <article
            key={item.id}
            className={styles.newsCard}
          >

            <div className={styles.newsContent}>
              <div className={styles.newsHeader}>
  <div className={styles.sourceBadge}>
    {item.source.replace("_", " ").toUpperCase()}
  </div>

  <div className={styles.newsDate}>
    {new Date(item.publishedAt).toLocaleDateString()}
  </div>
</div>

              <h3 className={styles.title}>
                {item.title}
              </h3>
              <div className={styles.newsStats}>
  <span>Business News</span>
  <span>•</span>
  <span>2 min read</span>
</div>
              <div className={styles.insightBox}>
                <div className={styles.insightBar} />

                <div>
                  <h4>{point}</h4>
                  <p>{description}</p>
                </div>
              </div>

              {whyItMatters && (
                <div className={styles.whyMatters}>
                  <span>💡 Why it matters</span>
                  <p>{whyItMatters}</p>
                </div>
              )}

              <a
                href={item.url}
                target="_blank"
                rel="noreferrer"
                className={styles.readMore}
              >
                Read Full Article →
              </a>
            </div>
          </article>
        );
      })}
    </div>
  );
}